import { Input, Pagination, Select } from "antd";
import type { JournalSectionPaginationState } from "../../model/use-journal-section-pagination";
import "./journal-section-pagination.scss";

const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

type JournalSectionPaginationProps = {
  pagination: JournalSectionPaginationState;
  total: number;
};

export const JournalSectionPagination = ({
  pagination,
  total,
}: JournalSectionPaginationProps) => {
  const { page, setPage, limit, onLimitChange, jumpPage, setJumpPage, onJump } =
    pagination;

  return (
    <div className="journal-section-pagination">
      <div className="journal-section-pagination__left">
        <Pagination
          current={page}
          pageSize={limit}
          total={total}
          showSizeChanger={false}
          onChange={setPage}
        />
      </div>

      <div className="journal-section-pagination__right">
        <span className="journal-section-pagination__label">Перейти к странице</span>
        <Input
          className="journal-section-pagination__jump"
          value={jumpPage}
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          onChange={(e) => setJumpPage(e.target.value.replace(/[^\d]/g, ""))}
          onPressEnter={() => onJump(total)}
          onBlur={() => onJump(total)}
        />
        <span className="journal-section-pagination__label">Записей на странице</span>
        <Select
          className="journal-section-pagination__size"
          value={limit}
          options={PAGE_SIZE_OPTIONS.map((v) => ({ value: v, label: v }))}
          onChange={onLimitChange}
        />
      </div>
    </div>
  );
};
